import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router';
import {withRouter} from 'react-router-dom';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';

// Material UI
import { withStyles } from 'material-ui/styles';

// Authentication
import { auth } from '../../../../../../../../config/constants/database';

// Styles
import styles from './styles';


class Submit extends Component {

  constructor(props){
    super(props);

    this.state = {

    };
    this.handleYes = this.handleYes.bind(this);
  }

  handleYes = () => {
    auth().signOut().catch(function(error) {
      if (error) {
        alert(error.message);
      } else {
        window.location.href = '/';
      }
    });
  }

  handleNo = () => {
    window.location.href = '/console';
  }

  render(){
    const { classes, location} = this.props;

    return(
      <div className={classes.root}>
        <Button raised color="secondary" onClick={() => this.handleYes()} align="center" className={classes.button}>YES</Button>
        <div className={classes.space}></div>
        <Button raised color="primary" onClick={() => this.handleNo()} align="center" className={classes.button}>NO</Button>
      </div>
    );
  }
}

Submit.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        customer_number: state.customer.number,
        project_id: state.prefix.project_id,
        email: state.email.email,
        password: state.password.password,
    };
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps)(Submit)));



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/LogOut/components/CoreContent/components/Submit/index.js